import styled from "styled-components";

export const Body = styled.div`
  background: white;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  position: relative;
`;
export const Left = styled.aside`
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.02);
  position: sticky;
  top: 0;
  width: 18%;
  /* overflow-y:scroll; */
  height: calc(100vh-70px);

  &::-webkit-scrollbar {
    visibility: hidden;
    width: 5px;
  }

  &:hover {
    &::-webkit-scrollbar {
      visibility: visible;
    }
    &::-webkit-scrollbar-thumb {
      background: #e2c6a2;
      border-radius: 5px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
`;
export const Right = styled.div`
  padding: 20px 0;
  background-color: #fafcfe;
  /* overflow-y:scroll; */
  width: 88%;
  display: flex;
  flex-direction: column;
`;
